import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

let active = false;
let wheels = document.getElementsByClassName('fx--spin');

let _tire;
let _wheel;

spinTheWheels( wheels );

function spinTheWheels( wheels ){
    active = true;

    _tire = gsap.to(wheels[0], {
        rotation: -200,
        transformOrigin: 'center center',
        ease: "none",
        scrollTrigger: {
            trigger: ".module--need-want",
            scrub: true
        }
    });

    _wheel = gsap.to(wheels[1], {
        rotation: -200,
        transformOrigin: 'center center',
        ease: "none",
        scrollTrigger: {
            trigger: ".module--need-want",
            scrub: true
        }
    });
}


function destroyWheel( wheels ){
    active = false;

    if(_tire && _wheel){
        _tire.scrollTrigger.disable();
        _wheel.scrollTrigger.disable();

        wheels[0].removeAttribute('style');
        wheels[1].removeAttribute('style');
    }
}